import { React, } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Feedback from './pages/dar-feedback';
import AcompanhamentoPsicologicoForm from './pages/acompanhamento-psicologico';
import AcompanhamentoPsiquiatricoForm from './pages/acompanhamento-psiquiatrico';
import AcompanhamentoNutricionalForm from './pages/acompanhamento-nutricional';
import AtendimentoPresencial from './pages/locais';
import Posts from './pages/posts';
import Inicio from './pages/index';
import PsicoterapiaCasalForm from './pages/psicoterapia-casal';
import AvaliacaoPsicologicaForm from './pages/avaliacao-psicologica';
import ContratacaoPalestrasForm from './pages/contratacao-palestras';

export default function AppRoutes() {

    return (
        <Routes>
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/" element={<Inicio />} />
            {/* <Route path="/sobre" element={<About />} /> */}
            {/* <Route path="/sobre2" element={<About2 />} /> */}
            <Route path="/posts" element={<Posts />} />
            <Route path="/atendimento-presencial" element={<AtendimentoPresencial />} />
            <Route path="/contratacao-palestras" element={<ContratacaoPalestrasForm />} />
            <Route path="/avaliacao-psicologica" element={<AvaliacaoPsicologicaForm />} />
            <Route path="/acompanhamento-psicologico" element={<AcompanhamentoPsicologicoForm />} />
            <Route path="/acompanhamento-psiquiatrico" element={<AcompanhamentoPsiquiatricoForm />} />
            <Route path="/acompanhamento-nutricional" element={<AcompanhamentoNutricionalForm />} />
            <Route path="/psicoterapia-casal" element={<PsicoterapiaCasalForm />} />
            <Route path="/dar-feedback" element={<Feedback />} />
        </Routes>
    );
}